import React, { useState } from 'react';
import { Modal } from 'react-bootstrap';
import { useCanvaAuth } from '../contexts/CanvaAuthContext2.tsx';
import {
  CANVA_HELP_DEFAULTS,
  CANVA_HELP_STRING_KEYS,
} from '../config/canvaHelpStrings.ts';

const YOUTUBE_EMBED_ID = 'GgeRBFdmwfs';
const CONTACT_EMAIL = 'service@muzaic.ai';

const CanvaHelpFab: React.FC = () => {
  const [show, setShow] = useState(false);
  const { canvaAuthenticated } = useCanvaAuth();
  const strings = canvaAuthenticated?.env?.strings as Record<string, string> | undefined;

  const t = (key: string) => strings?.[key] ?? CANVA_HELP_DEFAULTS[key] ?? key;

  return (
    <>
      <button
        type="button"
        className="canva-help-fab"
        onClick={() => setShow(true)}
        aria-label={t(CANVA_HELP_STRING_KEYS.fabAria)}
        aria-haspopup="dialog"
        aria-expanded={show}
      >
        ?
      </button>

      <Modal
        show={show}
        onHide={() => setShow(false)}
        centered
        scrollable
        contentClassName="canva-help-modal"
        dialogClassName="canva-help-modal-dialog"
      >
        <Modal.Header closeButton>
          <Modal.Title as="h2" className="h5 mb-0">
            {t(CANVA_HELP_STRING_KEYS.modalTitle)}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="ratio ratio-16x9 canva-help-modal-video rounded-3 overflow-hidden mb-4">
            <iframe
              src={`https://www.youtube.com/embed/${YOUTUBE_EMBED_ID}`}
              title={t(CANVA_HELP_STRING_KEYS.videoTitle)}
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowFullScreen
              className="border-0"
            />
          </div>
          <p className="mb-0 text-center small text-muted">
            {t(CANVA_HELP_STRING_KEYS.contactPrefix)}{' '}
            <a href={`mailto:${CONTACT_EMAIL}`} className="canva-help-modal-mail">
              {CONTACT_EMAIL}
            </a>
          </p>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default CanvaHelpFab;
